import Vue from 'vue';
import Component from 'vue-class-component';
import moment from 'common/deps/moment';

@Component({
  props: {
    campaign: {
      type: Object,
      required: true,
    },
  },
})
export default class CustomCampaignCoverComponent extends Vue {
  timeLeft = null;

  beforeMount() {
    if (this.campaign.show_counter) {
      this.setTimer(this.campaign.end_date);
    }
  }

  /* Set the timeLeft for the countdown calculing the difference
   * between endDate and the current date every minute
   */
  setTimer(endDate) {
    this.timeLeft = moment.duration(moment(endDate).diff(moment()));
    setTimeout(() => {
      this.setTimer(endDate);
    }, 60000);
  }

  get getDays() {
    return this.campaign ? this.timeLeft.days() : '0';
  }

  get getHours() {
    return this.campaign ? this.timeLeft.hours() : '0';
  }

  get getMinutes() {
    return this.campaign ? this.timeLeft.minutes() : '0';
  }
}
